import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getOrderReviews } from "../../../api/customerReview";

export const fetchReviewList = createAsyncThunk(
  "/review-list",
  async (payload) => {
    const res = await getOrderReviews(payload);
    return res;
  }
);
const reviewSlice = createSlice({
  name: "review",
  initialState: {},
  reducers: {},
  isLoading: false,
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviewList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchReviewList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.res = action.payload;
      })
      .addCase(fetchReviewList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});
export { reviewSlice };
